module.exports = __webpack_public_path__ + "static/workshop-full-471c908820029b359f5ca92a769f39e2.jpeg";